import { StreamActions, StreamElement } from '@hotwired/turbo'

/**
 * Custom Turbo Stream action that removes a submission from the table
 * only if the user no longer has access to it.
 *
 * When a submission's rep_code_id changes, the backend broadcasts
 * a removal to the old room. But the user might still have access via
 * another rep code — in that case, we skip the removal.
 */
StreamActions.remove_if_lost_access = function (this: StreamElement) {
  const newRepCode = this.getAttribute('new-rep-code')
  const identityRole = this.getAttribute('identity-role')
  const accessibleRepCodes = document.getElementById('submissions-table')?.dataset.accessibleRepCodes?.split(',') ?? []

  if (accessibleRepCodes.includes(newRepCode ?? '')) {
    return
  }

  // Only advisors have submissions lose access VIA rep code changes
  if (identityRole !== 'advisor') {
    return
  }

  this.targetElements.forEach(element => {
    element.remove()
  })
}
